import React, { useState ,useEffect} from 'react';
import RadioInput from '../../../Shared/RadioInput/RadioInput';
import TextInput from '../../../Shared/TextInput/TextInput';
import {Container} from 'reactstrap';
import { regexPatterns } from '../../../../utilities/validation/validationVariables';

const SelectNewFamilyNumberComponent = ({setIsSelected,isSelected, onPhoneNumberChange, setIsSubmit}) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState('');
  let regex = new RegExp(regexPatterns.phoneRegex);


  const handleRadioInputChange = () => {
    setIsSelected();
  }

  const handleNewInputChange = (e) => {
    const newPhoneNumber = e.target.value;
    setPhoneNumber(newPhoneNumber);
    onPhoneNumberChange(newPhoneNumber);
    if (!regex.test(newPhoneNumber)) {
      setError('חובה להזין מספר טלפון תקין');
      setIsSubmit(false);
    } else {
      setError('');
      setIsSubmit(true);
    }
  }

  return (
    <Container className='subscriber-item p-0 customer-info'>
      <div className='customer-info-content'>
        <div className={`${isSelected ? 'active' : ''} info`}>
              <div className='NewFamilyRadio'>
                <input
                    type="radio"
                    id={'radioBtn'+phoneNumber}
                    checked={isSelected}
                    onChange={handleRadioInputChange}
                  />
                <label htmlFor={'radioBtn'+phoneNumber}>
                  <div className="radio-icon"></div>
                  <div className="details">קו אחר {window.Config.brand_Name_HE}, שאינו בבעלותך</div>
                </label>
              </div>
          </div>
          {isSelected && (
              <div className='isChecked-NewFamilyMember'>
                <span className='isChecked-NewFamilyMember-title'>איזה מספר אנחנו מצרפים לתוכנית?</span>
                <span className="isChecked-NewFamilyMember-text">
                      מספר הטלפון אותו תרצו לצרף לתוכנית יקבל בדקות הקרובות לינק ב-SMS להשלמת ההצטרפות
                </span>
                <TextInput
                  className={'textInput-NewFamilyMember-button'}
                  onChange={(e) => handleNewInputChange(e)}
                  value={phoneNumber}
                  name='id'
                  type='tel'
                  error={error}
                  placeholder='מספר הטלפון אותו תרצו לצרף'
                />
              </div>
           )}
      </div>
    </Container>
  );
};


export default SelectNewFamilyNumberComponent;
